import React from "react";
import { Button } from "react-bootstrap";
import { PlusIcon } from "Components/Icons/PlusIcon";

interface CustomButtonProps {
    children: React.ReactNode;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const CustomActionButton = React.forwardRef<HTMLButtonElement, CustomButtonProps>(
    ({ children, onClick }, ref) => (
    <Button
        ref={ref}
        variant="primary"
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
        className="d-flex align-items-center"
    >
        <PlusIcon className="me-2" />
        {children}
    </Button>
));

CustomActionButton.displayName = "CustomActionButton";

export default CustomActionButton;